<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="区域：">
        <el-cascader
          v-model="addressValue"
          :options="addressOptions"
          :props="cascaderProps"
          placeholder="请选择区域（建议选择到区级）"
          clearable
          size="small"
          @change="handleAddressChange"
          style="width: 250px;"
        ></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import liveManageApi from '@/api/live/liveManage'
import { filterEmpty } from '@/utils'
export default {
  data() {
    return {
      addressValue: [], // 级联选择器的值
      addressOptions: [], // 区域选项数据
      cascaderProps: {
        value: 'regionCode',
        label: 'regionName',
        children: 'child',
        checkStrictly: false, // 必须选择到叶子节点，自动选中父级
        emitPath: true, // 返回完整路径
        lazy: false // 不使用懒加载
      },
      query: {
        addrAreaCode: undefined, // 区
        addrCityCode: undefined, // 市
        addrProvinceCode: undefined, // 省
        liveId: 0
      },
    }
  },
  created() {
    // 从路由参数获取区域和liveId
    const routeQuery = this.$route.query
    if (routeQuery.liveId) {
      this.query.liveId = parseInt(routeQuery.liveId)
    }
    if (routeQuery.addrProvinceCode) {
      this.query.addrProvinceCode = routeQuery.addrProvinceCode
    }
    if (routeQuery.addrCityCode) {
      this.query.addrCityCode = routeQuery.addrCityCode
    }
    if (routeQuery.addrAreaCode) {
      this.query.addrAreaCode = routeQuery.addrAreaCode
    }
    
    // 如果有区域参数，设置级联选择器的值
    if (this.query.addrProvinceCode) {
      this.addressValue = [
        this.query.addrProvinceCode,
        this.query.addrCityCode,
        this.query.addrAreaCode
      ].filter(item => item) // 过滤掉空值
    }
    
    this.loadAddressData()
  },
  methods: {
    /**
     * 加载区域数据
     */
    async loadAddressData() {
      try {
        const response = await liveManageApi.getAddressTreeList({})
        if (response.code === '0' && response.data) {
          // 处理数据，移除第4级（如果有的话）
          this.addressOptions = this.processAddressData(response.data)
        }
      } catch (error) {
        console.error('加载区域数据失败:', error)
      }
    },
    
    /**
     * 处理区域数据，确保只显示省市区三级，移除第4级
     */
    processAddressData(data) {
      if (!Array.isArray(data)) {
        return []
      }
      return data.map(province => {
        const processedProvince = { ...province }
        if (processedProvince.child && Array.isArray(processedProvince.child)) {
          processedProvince.child = processedProvince.child.map(city => {
            const processedCity = { ...city }
            // 如果市下面还有子级（第4级），移除它
            if (processedCity.child && Array.isArray(processedCity.child)) {
              processedCity.child = processedCity.child.map(district => {
                // 移除区下面的子级（第4级）
                const processedDistrict = { ...district }
                if (processedDistrict.child) {
                  delete processedDistrict.child
                }
                return processedDistrict
              })
            }
            return processedCity
          })
        }
        return processedProvince
      })
    },
    
    /**
     * 区域级联选择器变化处理
     */
    handleAddressChange(value) {
      if (value && value.length > 0) {
        // 根据选择的层级设置对应的区域代码
        this.query.addrProvinceCode = value[0] || undefined
        this.query.addrCityCode = value[1] || undefined
        this.query.addrAreaCode = value[2] || undefined
      } else {
        // 清空选择时重置所有区域代码
        this.query.addrProvinceCode = undefined
        this.query.addrCityCode = undefined
        this.query.addrAreaCode = undefined
      }
    },
    
    handleDownload() {
      let params = JSON.parse(JSON.stringify(this.query))
      params.pageNo = 1
      params.pageSize = 1000
      return this.$common.confirm('是否确认导出')
        .then(() => liveManageApi.downloadStatisticsByLive(filterEmpty(params))).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          }
        })
    },
  }
}
</script>

<style>
</style>

